import { EyeOutlined } from '@ant-design/icons';
import { localize } from 'mixins/helpers';
import React, { useEffect } from 'react';
import bvi from '/react4xp/parts/button-visually-impaired/bvi';
import bviOptions from '/react4xp/parts/button-visually-impaired/bvi-init';

import '/react4xp/parts/button-visually-impaired/button-visually-impaired.scss';
import '/react4xp/parts/button-visually-impaired/bvi.scss';

const ButtonVisuallyImpaired = (props: any) => {
    useEffect(() => {
        if (props.translations) {
            bvi(bviOptions, props);
        }
    }, [props.translations]);

    return (
        <div>
            <button
                className="bvi-open bvi-styles"
                id="bvi-opened"
            >
                <EyeOutlined
                    className="EyeOutlined"
                    size={10}
                />
                <div className="bvi-text bvi-open hide-on-tablet hide-on-mobile">
                    {localize('button-visually-impaired', props.translations)}
                </div>
            </button>
        </div>
    );
};

export default ButtonVisuallyImpaired;
